import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { usersService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useGetAffectedUsersMutation = (companyId: { companyId: string }) => {
	const dispatch = useDispatch();

	return useMutation(
		(domains: { domains: { [key: string]: any }[] }) => {
			return usersService.getAffectedUsers({ companyId, domains });
		},
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useGetAffectedUsersMutation;
